<h1 mat-dialog-title>{{'ARE_YOU_SURE' | translate}}</h1>
<div mat-dialog-content>
  <div class="action-buttons">
    <button mat-raised-button color="warn" (click)="dialogRef.close(true)">{{'YES' | translate}}</button>
    <button mat-raised-button (click)="dialogRef.close(false)">{{'DECLINE_2' | translate}}</button>
  </div>
</div>
